import { Grid, TextField } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import { translations } from 'locales/i18n';
import { useTranslation } from 'react-i18next';

export function UserInformation() {
  const { t } = useTranslation();

  const { errors }: any = useFormikContext();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field
            as={TextField}
            name="email"
            error={errors.email}
            helperText={errors.email}
            fullWidth
            required
            label={t(translations.common.email())}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            as={TextField}
            name="firstName"
            error={errors.firstName}
            helperText={errors.firstName}
            fullWidth
            required
            label={t(translations.common.firstName())}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            as={TextField}
            name="lastName"
            error={errors.lastName}
            helperText={errors.lastName}
            fullWidth
            required
            label={t(translations.common.lastName())}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            as={TextField}
            name="homeUniversity"
            error={errors.homeUniversity}
            helperText={errors.homeUniversity}
            fullWidth
            required
            label={t(translations.pages.internationalOffice.users.homeUniversity())}
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            as={TextField}
            name="courseOfStudies"
            error={errors.courseOfStudies}
            helperText={errors.courseOfStudies}
            fullWidth
            required
            label={t(translations.pages.internationalOffice.users.courseOfStudies())}
          />
        </Grid>
        <Grid item xs={3}>
          <Field
            as={TextField}
            name="semester"
            error={errors.semester}
            helperText={errors.semester}
            fullWidth
            required
            label={t(translations.pages.internationalOffice.users.semester())}
          />
        </Grid>
      </Grid>
    </>
  );
}
